import React from 'react';

export class PageActions extends React.Component{

	constructor(props) {
        super(props);

        this.state = {
        	btnDelete:{ active: false, handle: ''},
        	btnEdit:{ active: false, handle: ''},
        	btnSave:{ active: false, handle: ''}
        }

    }

	componentWillMount(){
		const { handle, active } = this.props;

		let dummyState = {};

		active.map(function(active, i){
			dummyState={...dummyState, [active]:{active:true, handle:handle[i]}};
		});
		
		this.setState(dummyState);
	}

	render(){
		const { btnDelete, btnEdit, btnSave } = this.state;
		return(
			<div className="btn-placeholder">
			{ btnDelete.active &&
				<button type="submit" className="btn btn-danger" onClick={btnDelete.handle}>
			      <span className="visible-xs"><i className="fa fa-trash"></i></span>
			      <span className="hidden-xs">Delete</span>
			    </button>
			}
		    { btnEdit.active &&
				<button type="submit" className="btn btn-warning" onClick={btnEdit.handle}>
		          <span className="visible-xs"><i className="fa fa-pencil"></i></span>
		          <span className="hidden-xs">Edit</span>
		        </button>
			}
			{ btnSave.active &&
				<button type="submit" className="btn btn-primary" onClick={btnSave.handle}>
		          <span className="visible-xs"><i className="fa fa-check"></i></span>
		          <span className="hidden-xs">Save</span>
		        </button>
			}  
		    </div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/PageActions.js